const superNumber = 2;

export const numberUnits = (step: number) => step * superNumber;
